import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { WindowService } from '../window/window.service';
import { HelpWindowComponent } from './help-window/help-window.component';

@Injectable({
  providedIn: 'root'
})
export class TopicService {

  private topicEmmiter = new BehaviorSubject<string>(null);

  topic$ = this.topicEmmiter.asObservable();

  constructor() { }

  setTopic(topicId: string) {
    this.topicEmmiter.next(topicId);
  }
}
